import { Funcionario } from 'components/autocompletes/FuncionarioAutoComplete';
import { useListagemContext } from 'context/ListagemContext';

export function useFuncionarioFilter(): Funcionario | null {
    const { fullFilterData } = useListagemContext();
    const filterLoja = fullFilterData?.find((filter) => filter.value.property === 'idUsuarioPedido');

    return filterLoja?.value.value || null;
}
